import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import JSZip from 'jszip';
import { from, Observable, of, switchMap } from 'rxjs';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { DocPreviewUtilityService } from '../doc-preview-utility.service';

@Injectable({
  providedIn: 'root'
})
export class ZipPreviewResolver implements Resolve<boolean> {
  constructor(
    private helpers: HelpersService,
    private zipUtility: DocPreviewUtilityService
  ) {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let idDocument = route.paramMap.get('idDocumento')!;
    let refDocumentale = route.paramMap.get('refDocumentale')!;
    if(!!refDocumentale) {
      return this.zipPreviewByRef(refDocumentale);
    }
    if(idDocument === "buffer") {
      return of(true);
    }
    return this.zipPreview(idDocument)
  }

  private zipPreviewByRef(refDocumentale: string) {
    return this.helpers.showPreviewWithRefDocumentale(refDocumentale).pipe(
      switchMap(res => {
        if (!!res) {
          return from(
            this.zipUtility.onFileZipSelected(res.body)
          );
        } else {
          return of(false);
        }
      })
    );
  }


  private zipPreview(idDocument: string): Observable<any> {
    return this.helpers.getPreview(idDocument).pipe(
      switchMap(res => {
        if (!!res) {
          return from(
            this.zipUtility.onFileZipSelected(res.body)
          );
        } else {
          return of(false);
        }
      })
    );
  }
}
